var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKindergartenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_247_9418",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_247_9418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 18.9999H9.34625V13.9614C9.34625 13.7054 9.43283 13.4907 9.606 13.3174C9.77933 13.1442 9.994 13.0576 10.25 13.0576H13.75C14.006 13.0576 14.2207 13.1442 14.394 13.3174C14.5672 13.4907 14.6538 13.7054 14.6538 13.9614V18.9999H18V10.1536C18 10.1025 17.9888 10.056 17.9663 10.0144C17.9439 9.9727 17.9135 9.93578 17.875 9.90362L12.1828 5.62487C12.1314 5.58003 12.0705 5.55762 12 5.55762C11.9295 5.55762 11.8686 5.58003 11.8173 5.62487L6.125 9.90362C6.0865 9.93578 6.05608 9.9727 6.03375 10.0144C6.01125 10.056 6 10.1025 6 10.1536V18.9999ZM4.5 18.9999V10.1536C4.5 9.86745 4.564 9.59637 4.692 9.34037C4.82017 9.0842 4.99717 8.87328 5.223 8.70762L10.9155 4.41912C11.2313 4.17812 11.5923 4.05762 11.9985 4.05762C12.4047 4.05762 12.7667 4.17812 13.0845 4.41912L18.777 8.70762C19.0028 8.87328 19.1798 9.0842 19.308 9.34037C19.436 9.59637 19.5 9.86745 19.5 10.1536V18.9999C19.5 19.4089 19.3523 19.7611 19.0568 20.0566C18.7613 20.3521 18.409 20.4999 18 20.4999H14.0577C13.8016 20.4999 13.5869 20.4132 13.4137 20.2399C13.2404 20.0667 13.1538 19.852 13.1538 19.5959V14.5576H10.8463V19.5959C10.8463 19.852 10.7596 20.0667 10.5863 20.2399C10.4131 20.4132 10.1984 20.4999 9.94225 20.4999H6C5.591 20.4999 5.23875 20.3521 4.94325 20.0566C4.64775 19.7611 4.5 19.4089 4.5 18.9999Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKindergartenIcon);
export default __webpack_public_path__ + "static/media/kindergarten-icon.b3d37295b0c6ff520ec814a34c8fc41b.svg";
export { ForwardRef as ReactComponent };